import { render, staticRenderFns } from "./dy-title.vue?vue&type=template&id=6b3bedb7&scoped=true"
import script from "./dy-title.vue?vue&type=script&lang=js"
export * from "./dy-title.vue?vue&type=script&lang=js"
import style0 from "./dy-title.vue?vue&type=style&index=0&id=6b3bedb7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3bedb7",
  null
  
)

export default component.exports